import { Component, Inject, inject } from '@angular/core';
import { MatSnackBarRef, MatSnackBarModule, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { SnackBarType } from '@core/enums/snack-bar-type.enum';
import { SnackBarData } from '@core/models/snack-bar-data.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    imports: [
        MatButtonModule, 
        MatSnackBarModule, 
        SafeHtmlPipe, 
        MatIconModule, 
        CommonModule,
        TranslateModule,
    ]
})
export class SnackBarComponent {
    readonly SERVER_ERROR_TRANSLATION_KEY = 'server.error.error';

    snackBarRef = inject(MatSnackBarRef);
    SnackBarType = SnackBarType;

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData,
    ) {}
}
